import { ArticleMedia } from 'ui/components';

export const ArticleMediaFeature: React.FC<Umbraco.ArticleMedia> = ({ content }) => <ArticleMedia {...content?.properties} />;
